import { HashRouter } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import "./App.scss";
import Routing from "./routing/Routing";
import { AppLogout, AxiosInterceptor } from "config/axiosInstance";
import 'react-phone-input-2/lib/bootstrap.css'
import { Provider } from "react-redux";
import appStore from "store/appStore";
import "./index.css";



function App() {
  return (
    <div className="App">
      <HashRouter>
        <Provider store={appStore}>
          < AxiosInterceptor>
            <AppLogout>
              <Routing />
            </AppLogout>
          </AxiosInterceptor>
        </Provider>
      </HashRouter>
    </div>
  );
}

export default App;
